<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Dosificaciones de la sucursal </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </template>

    <EventosReg ref="eventosreg" v-on:newregdosis="newregdosis" />
  </div>
</template>

<script>
  import EventosReg from '@/views/dosificacionesx/registrar.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      headers: [
        { text: 'Actividad', value: 'actividad' },
        { text: 'Estado', value: 'estado' },
        { text: 'Numero autorizacion', value: 'numero_autorizacion' },
        { text: 'Numero inicial factura', value: 'numero_inicial_factura', width: 130 },
        { text: 'Nit', value: 'nit' },
        { text: 'Opciones', value: 'opciones', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { EventosReg },

    methods: {
      initialize() {
        let idsucursal = this.$route.query.idsucursal;
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/dosificaciones?sucursal_id=${idsucursal}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            window.console.log('dosis:', data);
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregdosis(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.nit = item.nit;
          e.numero_inicial_factura = item.numero_inicial_factura;
          e.numero_autorizacion = item.numero_autorizacion;
          e.llave_dosificacion = item.llave_dosificacion;
          e.tipo_documento_id = item.tipo_documento_id;
          e.actividad = item.actividad;
          e.linea1 = item.linea1;
          e.linea2 = item.linea2;
          e.fecha_limite = item.fecha_limite;
        } else {
          this.initialize();
        }
      },

      editItem(item) {
        if (item) {
          this.editedItem = Object.assign({}, item);
          this.$refs.eventosreg.openmodal(this.editedItem);
        } else {
          this.$refs.eventosreg.openmodal();
        }
      },
    },
    mounted() {
      this.initialize();
    },
  };
</script>
